/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdUsersStudents200,
  GetApiV1ClassroomdisciplineIdUsersStudents401,
  GetApiV1ClassroomdisciplineIdUsersStudents404,
  GetApiV1ClassroomdisciplineIdUsersStudentsPathParams,
  GetApiV1ClassroomdisciplineIdUsersStudentsQueryParams,
  GetApiV1ClassroomdisciplineIdUsersStudentsQueryResponse,
} from "../../types/classPlanningPeopleController/GetApiV1ClassroomdisciplineIdUsersStudents.ts";
import { classroomUserStudentListItemViewModelSchema } from "../classroomUserStudentListItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdUsersStudentsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersStudentsPathParams>;

export const getApiV1ClassroomdisciplineIdUsersStudentsQueryParamsSchema = z
  .object({
    PageNumber: z.optional(z.coerce.number().int()),
    PageSize: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersStudentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdUsersStudents200Schema = z.array(
  z.lazy(() => classroomUserStudentListItemViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersStudents200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdUsersStudents401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersStudents401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdUsersStudents404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersStudents404>;

export const getApiV1ClassroomdisciplineIdUsersStudentsQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdUsersStudents200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersStudentsQueryResponse>;
